const { default: BrowseEmployeeRoute } = require("./BrowseEmployee/BrowseEmployeeRoute");
const { default: Route } = require("./DetailEmployee/Route");

export default { BrowseEmployeeRoute, DetailEmployeeRoute: Route }